Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsDarkMode = void 0;
exports.supportsDarkMode = () => {
    const isServer = typeof window === 'undefined';
    return (!isServer &&
        window.matchMedia('(prefers-color-scheme: dark)').matches === true);
};
//# sourceMappingURL=supports-dark-mode.js.map